import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
} from "reactstrap";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import {
  updateEmployeeByEmployerId,
  updateIndividualById,
} from "../../../slices/general/thunk";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const EditEmployeeModal = ({
  open,
  setOpen,
  editUser,
  setUser,
  onRefreshTable,
  isIndividual
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const toggleModalEditUser = () => {
    setOpen(!open);
  };

  const isIndividualEdit = editUser.individualCode || isIndividual;

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
  });

  const handleEditUser = async (values) => {
    setLoading(true);
    try {
      const actionToDispatch = isIndividualEdit
        ? updateIndividualById({
          individualId: editUser.id,
          data: values,
        })
        : updateEmployeeByEmployerId({
          employerId: editUser.employerId,
          employeeId: editUser.id,
          data: values,
        });

      const response = await dispatch(actionToDispatch).unwrap();

      if (!response.error) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `${isIndividualEdit ? "Individual" : "Employee"
            } updated successfully`,
        });
        toggleModalEditUser();
        onRefreshTable();
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.error.message,
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={open} toggle={toggleModalEditUser}>
      <ModalHeader toggle={toggleModalEditUser}>
        Edit {isIndividualEdit ? "Individual" : "Employee"}
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={{
            firstName: editUser.firstName,
            lastName: editUser.lastName,
            email: editUser.email,
          }}
          validationSchema={validationSchema}
          onSubmit={handleEditUser}
        >
          {({ isSubmitting, dirty, isValid }) => (
            <Form>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <Field
                  type="email"
                  name="email"
                  className="form-control"
                  disabled
                />
              </div>
              <div className="mb-3">
                <label htmlFor="firstName" className="form-label">
                  First Name
                </label>
                <Field type="text" name="firstName" className="form-control" />
                <ErrorMessage
                  name="firstName"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="lastName" className="form-label">
                  Last Name
                </label>
                <Field type="text" name="lastName" className="form-control" />
                <ErrorMessage
                  name="lastName"
                  component="div"
                  className="text-danger"
                />
              </div>

              <Row>
                <Col className="col-6">
                  <Button
                    color="soft-primary"
                    className="border border-primary w-100"
                    onClick={toggleModalEditUser}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col className="col-6">
                  <Button
                    type="submit"
                    color="primary"
                    className="w-100"
                    disabled={isSubmitting || !dirty || !isValid || loading}
                  >
                    {isSubmitting ? (
                      <div className="spinner-border spinner-border-sm mr-3"></div>
                    ) : (
                      "Save"
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default EditEmployeeModal;
